export const META_TYPE = 'tibberPrice';
export const META_VER = 'v1';

export const CMD_TIBBERPRICE_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
